import React, { useContext } from 'react'
import { Route, BrowserRouter, NavLink } from 'react-router-dom'
import ActivityLog from './ActivityLog'
import NewsLog from './NewsLog'
import UserLog from './UserLog'
import "./ActivityNavigation.css"
import { LanguageContext } from '../Language/LanguageContext'
import { Container, TabButton } from '../Library'
import { RoleContext } from '../Role/RoleContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faScroll, faKey, faNewspaper } from '@fortawesome/free-solid-svg-icons'

function ActivityNavigation() {
    const role = useContext(RoleContext)
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.activity_log

    return (
        <Container topbarTitle={lang.log}>
            <BrowserRouter basename="/log">
                <div className="nav-container">
                    <TabButton to="/" exact={true} title={lang.activity_log} icon={faScroll}/>
                    { role.checkPermission("_MENU_", "app.report_user_log") ?
                    <TabButton to="/user-log" title={lang.user_log} icon={faKey}/>
                    : null
                    }
                    { role.checkPermission("_MENU_", "app.report_news_log") ?
                    <TabButton to="/news-log" title={lang.news_log} icon={faNewspaper}/>
                    : null
                    }
                </div>
                <hr/>
                <Route path="/" exact>
                    <ActivityLog/>
                </Route>
                <Route path="/user-log">
                    <UserLog/>
                </Route>
                <Route path="/news-log">
                    <NewsLog/>
                </Route>
            </BrowserRouter>
        </Container>
    )
}

export default ActivityNavigation
